import React, { useState, useEffect } from 'react';
import axios from 'axios';
import colors from '../Constant/colors';

const FeeHeadPage = () => {
  const [feeHeads, setFeeHeads] = useState([]);
  const [headName, setHeadName] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  // Get sessionId from localStorage
  const sessionId = localStorage.getItem('currentSessionId');
  const sessionName=localStorage.getItem('currentSessionName');
  const inputStyle = {
    fontSize: "14px",
    border: "1px solid #1E40AF",
    padding: "10px",
    borderRadius: "8px",
    width: "100%",
    background: "#fff"
  };
  const buttonStyle = {
    fontSize: "14px",
    padding: "12px 24px",
    borderRadius: "8px",
    fontWeight: "600",
    color: "#fff",
    background: colors.gradientPrimary,
    border: "none",
    cursor: "pointer"
  };

  useEffect(() => {
    if (sessionId) fetchFeeHeads();
  }, [sessionId]);

  const fetchFeeHeads = async () => {
    try {
      const response = await axios.get(` ${process.env.REACT_APP_API_BASE_URL}/api/feeheads/getFeeHeads`, {
        params: { sessionId }
      });
      setFeeHeads(response.data);
    } catch (err) {
      console.error('Error fetching fee heads:', err);
      setError('Failed to fetch fee heads');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setIsLoading(true);

    try {
      const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/feeheads/createFeeHead`, {
        headName,
        sessionId
      });
      setFeeHeads([...feeHeads, response.data]);
      setHeadName('');
      setSuccess('Fee Head added successfully!');
    } catch (err) {
      setError(err.response?.data?.message || 'Error adding fee head');
    } finally {
      setIsLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this fee head?')) return;

    try {
      await axios.delete(` ${process.env.REACT_APP_API_BASE_URL}/api/feeheads/deleteFeeHead/${id}`, {
        params: { sessionId }
      });
      setFeeHeads(feeHeads.filter(fh => fh._id !== id));
      setSuccess('Fee Head deleted successfully!');
    } catch (err) {
      setError(err.response?.data?.message || 'Error deleting fee head');
    }
  };

  return (
    <div className="min-h-screen bg-white flex justify-center py-6 px-4">
      <div className="w-full max-w-5xl">

        <header className="mb-6">
          <p style={{ fontSize: "14px", color: "#555" }}>
            Add, view, and manage fee heads for session: {sessionName}
          </p>
        </header>

        <div className="bg-white rounded-lg shadow-lg mb-6 p-4 border border-gray-200">
          <h2 style={{ fontSize: "18px", fontWeight: "600", color: "#000", marginBottom: "10px" }}>
            Add New Fee Head
          </h2>

          <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row sm:items-center gap-3">
            <input
              type="text"
              value={headName}
              onChange={(e) => setHeadName(e.target.value)}
              placeholder="Enter Fee Head Name"
              required
              style={inputStyle}
            />
            <button type="submit" disabled={isLoading} style={buttonStyle}>
              {isLoading ? 'Saving...' : 'Add'}
            </button>
          </form>

          {error && <p style={{ color: "red", fontSize: "14px", marginTop: "8px" }}>{error}</p>}
          {success && <p style={{ color: "green", fontSize: "14px", marginTop: "8px" }}>{success}</p>}
        </div>

        <div className="bg-white rounded-lg shadow-lg mb-6 p-4 border border-gray-200">
          <h2 style={{ fontSize: "18px", fontWeight: "600", color: "#000", marginBottom: "10px" }}>
            Existing Fee Heads
          </h2>

          {feeHeads.length > 0 ? (
            <div className="overflow-x-auto">
              <table className="min-w-full bg-white border border-gray-300 rounded-md">
                <thead className="bg-gray-50">
                  <tr>
                    {["#", "Fee Head Name", "Actions"].map((col, idx) => (
                      <th key={idx} className="px-4 py-2 border text-left" style={{ fontSize: "18px", fontWeight: "600", color: "#000" }}>
                        {col}
                      </th>
                    ))}
                  </tr>
                </thead>

                <tbody>
                  {feeHeads.map((fh, index) => (
                    <tr key={fh._id} className="hover:bg-gray-50">
                      <td className="px-4 py-2 border" style={{ fontSize: "14px" }}>{index + 1}</td>
                      <td className="px-4 py-2 border" style={{ fontSize: "14px" }}>{fh.headName}</td>
                      <td className="px-4 py-2 border">
                        <button
                          onClick={() => handleDelete(fh._id)}
                          className="bg-red-500 text-white px-4 py-1 rounded hover:bg-red-600"
                          style={{ fontSize: "14px" }}
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <p style={{ fontSize: "14px", color: "#444" }}>No fee heads found for this session.</p>
          )}
        </div>

      </div>
    </div>
  );
};

export default FeeHeadPage;
